import React from 'react';

import { createStyles } from '../tss';

const useStyles = createStyles(() => ({
  root: {},
  scrim: {
    transition: 'background-color 300ms ease, backdrop-filter 300ms ease',
    backgroundColor: 'rgba(0,0,0,0)',
    pointerEvents: 'none',
  },
  scrimActive: {
    pointerEvents: 'auto',
    backgroundColor: 'rgba(0,0,0,0.25)',
    backdropFilter: 'blur(1px)',
  },
  container: {},
}));

interface Props {
  children: React.ReactNode;
  className?: string;
  classes?: Partial<ReturnType<typeof useStyles>['classes']>;
  show: boolean;
}

export const Scrim: React.FC<Props> = ({
  children,
  classes: classesOverrides,
  className,
  show,
}) => {
  const { classes, cx } = useStyles({ classesOverrides });
  return (
    <div className={classes.root}>
      <div className={cx(classes.scrim, className, { [classes.scrimActive]: show })} />
      <div className={classes.container}>
        {children}
      </div>
    </div>
  );
};
